import { render, staticRenderFns } from "./TheCollection.vue?vue&type=template&id=324be767&"
import script from "./TheCollection.vue?vue&type=script&lang=js&"
export * from "./TheCollection.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TheCollection.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "ed86c7c8"
  
)

component.options.__file = "TheCollection.vue"
export default component.exports